import { Component } from 'react'

export const KEY_ENTER = 'Enter'
export const KEY_KODE_ENTER = 13
export const KEY_KODE_ESC = 27
export const KEY_KODE_SPACEBAR = 32
export const KEY_TAB = 'Tab'
export const KEY_DOWN = 'ArrowDown'
export const KEY_UP = 'ArrowUp'

export function isEnterPressed(event) {
  return event.key === KEY_ENTER
}

export function isEscPressed(event) {
  const keyCode = event.which || event.keyCode

  return keyCode === KEY_KODE_ESC
}

const isUpPressed = e => e.key === KEY_UP
const isDownPressed = e => e.key === KEY_DOWN

export function isTabPressed(event) {
  return !event.shiftKey && event.key === KEY_TAB
}

export function isShiftTabPressed(event) {
  return event.shiftKey && event.key === KEY_TAB
}

export function isSpacePressed(event) {
  const keyCode = event.which || event.keyCode

  return keyCode === KEY_KODE_SPACEBAR
}

class OnKeyDownCatcher extends Component {
  constructor(props) {
    super(props)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  handleKeyPress(event) {
    const {
      onEnter,
      onTab,
      onShiftTab,
      onEsc,
      onSpace,
      onAnyKey,
      preventDefaultOnTab,
      onUp,
      onDown,
    } = this.props

    if (onEnter && isEnterPressed(event)) {
      onEnter()
      return
    }

    if (onShiftTab && isShiftTabPressed(event)) {
      preventDefaultOnTab && event.preventDefault()
      onShiftTab()
      return
    }

    if (onTab && isTabPressed(event)) {
      preventDefaultOnTab && event.preventDefault()
      onTab()
      return
    }

    if (onDown && isDownPressed(event)) {
      onDown()
      return
    }

    if (onUp && isUpPressed(event)) {
      onUp()
      return
    }

    if (onEsc && isEscPressed(event)) {
      onEsc()
      return
    }

    if (onSpace && isSpacePressed(event)) {
      onSpace()
      return
    }

    if (onAnyKey) {
      onAnyKey()
    }
  }

  render() {
    const {
      children,
      onClick,
      onEnter,
      onTab,
      onShiftTab,
      onEsc,
      onSpace,
      onAnyKey,
      onUp,
      onDown,
      ...restOfProps
    } = this.props
    return (
      <div onKeyDown={this.handleKeyPress} onClick={onClick} {...restOfProps}>
        {children}
      </div>
    )
  }
}

export default OnKeyDownCatcher
